// src/modules/hr/components/EmployeeForm.tsx
import {
  Box,
  Grid,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";

interface EmployeeFormProps {
  initialValues?: {
    fullName: string;
    nationalId: string;
    phone: string;
    email?: string;
    position: string;
    department?: string;
    startDate: string;
  };
  saving: boolean;
  onSubmit: (data: any) => void;
}

const EmployeeForm: React.FC<EmployeeFormProps> = ({
  initialValues,
  saving,
  onSubmit,
}) => {
  const [form, setForm] = useState({
    fullName: initialValues?.fullName || "",
    nationalId: initialValues?.nationalId || "",
    phone: initialValues?.phone || "",
    email: initialValues?.email || "",
    position: initialValues?.position || "",
    department: initialValues?.department || "",
    startDate: initialValues?.startDate || "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Full Name"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="National ID"
              name="nationalId"
              value={form.nationalId}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Phone"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              fullWidth
              type="email"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Position"
              name="position"
              value={form.position}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Department"
              name="department"
              value={form.department}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Start Date"
              name="startDate"
              type="date"
              value={form.startDate}
              onChange={handleChange}
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        <Box mt={3}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={saving}
            fullWidth
          >
            {saving ? <CircularProgress size={24} color="inherit" /> : "Save Employee"}
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default EmployeeForm;
